// extracted by mini-css-extract-plugin
export default {"footer":"WebFooter_footer__iqhLR","logoBox":"WebFooter_logoBox__xDwqm","link":"WebFooter_link__HSz+i","linkBox":"WebFooter_linkBox__PWUVr"};